import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { TrustpilotWidget } from '../../../..';

import { TEMPLATE_IDS } from '../TrustpilotWidget/TrustpilotWidget';

import LandingSection from '../LandingSection/LandingSection';

import styles from './LandingTestimonialsSection.module.scss';

const LandingTestimonialsSection = ({
  renderTitle = null,
  backgroundColor = 'white',
  observableSection = null
}) => {
  return (
    <LandingSection
      className={classNames(
        styles['landing-testimonials-section'],
        styles[`landing-testimonials-section--${backgroundColor}`]
      )}
      observableSection={observableSection}
    >
      {renderTitle ? (
        renderTitle()
      ) : (
        <h2 className={styles['landing-testimonials-section__title']}>
          {trans('how_it_works.testimonials.title')}
        </h2>
      )}
      <TrustpilotWidget
        className={styles['landing-testimonials-section__widget']}
        template={TEMPLATE_IDS.SLIDER}
        width="100%"
        height={160}
      />
    </LandingSection>
  );
};

LandingTestimonialsSection.propTypes = {
  renderTitle: PropTypes.func,
  backgroundColor: PropTypes.oneOf(['secondary-blue-light', 'white']),
  observableSection: PropTypes.string
};

export default LandingTestimonialsSection;
